import { TPBANK, OCB, VIETTINBANK, PVCOMBANK, SMARTPAY, FACEPAY } from "../constant/supplierKey"
import { TERMINAL, FACE_POS } from "../constant/sourceKey";

// data error
import { dataErrorOCB } from "../dataErrorBank/dataErrorOCB";
import { dataErrorPVC } from "../dataErrorBank/dataErrorPVC";
import { dataErrorSmartpay } from "../dataErrorBank/dataErrorSmartpay";
import { dataErrorTPB } from "../dataErrorBank/dataErrorTPB";
import { dataErrorVTB } from "../dataErrorBank/dataErrorVTB";

import { dataErrorFacepay } from "../dataErrorBank/dataErrorFacepay";
import { dataErrorFacePos } from "../dataErrorBank/dataErrorFacePos";

import { dataErrorDeposit } from "../dataErrorDeposit/dataErrorDeposit";

export const mapErrorTransaction = ( data = {
    supplier: "",
    source: "",
    paymentCode: "",
    paymentDescription: "",
    isWallet: false
}) => {
    const { supplier, source, paymentCode, paymentDescription, isWallet } = data
    // let message = paymentDescription.length
    if(isWallet){
        return dataErrorDeposit[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
    }
    switch (supplier) {
        case FACEPAY:{
            if(!source){
                return dataErrorFacepay[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
            }
            switch (source) {
                case TERMINAL:{
                    return dataErrorFacepay[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
                }
                    break;
                case FACE_POS:{
                    return dataErrorFacePos[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
                }
                    break;

                default:{
                    return dataErrorFacepay[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
                }
                    break;
            }
        }
            break;
        case SMARTPAY:{
            return dataErrorSmartpay[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
        }
            break;
        case TPBANK:{
            return dataErrorTPB[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
        }
            break;
        case OCB:{
            return dataErrorOCB[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
        }
            break;
        case VIETTINBANK:{
            return dataErrorVTB[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
        }
            break;
        case PVCOMBANK:{
            return dataErrorPVC[paymentCode]?.text || (paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại")
        }
            break;
    
        default:{
            return paymentDescription.length > 0 ? paymentDescription : "Giao dịch thất bại"
        }
            break;
    }                           
}